import React from "react"
import PropTypes from 'prop-types';
import * as S from "./BannerAlert.Style"

const BannerAlert = ({icon, mainText, mainTitle, themeColor}) => {
    return (
        <S.Banner themeColor={themeColor}>
            <S.Content >
                {mainTitle && <S.MainTitle>{mainTitle}</S.MainTitle>}
                <S.TextWithIcon>
                    {icon && <S.icon>{icon}</S.icon>}
                    <S.MainText>{mainText}</S.MainText>
                </S.TextWithIcon>
            </S.Content>
        </S.Banner>
    )
}

BannerAlert.propTypes = {
    icon: PropTypes.element,
    mainTitle: PropTypes.string,
    mainText: PropTypes.string.isRequired,
    themeColor: PropTypes.bool
}

BannerAlert.defaultProps ={
    icon: null,
    mainTitle: "",
    themeColor: false,
}

export default BannerAlert